export default "__VITE_ASSET__BZO0CMTx__"